window.addEventListener('load', function() {
  var LOCALE_TO_COUNTRY = {
    'cs': 'CZ',
    'de': 'AT',
    'en': 'AT'
  };

  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function() {
    var form = this;
    if (form.action && form.action.indexOf('/localization') !== -1) {
      var langInput = form.querySelector('[name="language_code"]') || form.querySelector('[name="locale_code"]');
      var countryInput = form.querySelector('[name="country_code"]');
      if (langInput && countryInput) {
        var locale = langInput.value;
        var country = LOCALE_TO_COUNTRY[locale];
        if (country) {
          countryInput.setAttribute('value', country);
          Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(countryInput, country);
          console.log('Locale-Market-Sync: ' + locale + ' → ' + country);
        }
      }
    }
    nativeSubmit.call(this);
  };

  console.log('Locale-Market-Patch geladen ✓');
});